import { CONTENT_ASSESSOR_REGISTRATION_FIELDS } from './ContentAssessorRegistration';
import {
    ACADEMIC_QUALIFICATION_FIELDS,
    CURRENT_EMPLOYMENT_DETAILS_FIELDS,
    LANGUAGE_PROFICIENCY_FIELDS,
    RCA_REGISTER_DETAILS_FIELDS
} from './ContentAssessorProfileUpdate';

const CARegistration = [
    {
        formID: 'contentAssessorRegistration',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: CONTENT_ASSESSOR_REGISTRATION_FIELDS,
        submitBtn: { id: 'review', title: 'Review' }
    },
    {
        formID: 'academicQualifications',
        title: 'Academic Qualification',
        fieldIDTitle: 'academic-qualification-details',
        multiple: true,
        fields: ACADEMIC_QUALIFICATION_FIELDS,
        submitBtn: { id: 'submit-general', title: 'Next Section' }
    },
    {
        formID: 'languageProficiency',
        title: 'Language Proficiency',
        fieldIDTitle: 'language-proficiency-details',
        multiple: true,
        fields: LANGUAGE_PROFICIENCY_FIELDS,
        submitBtn: { id: 'submit-general', title: 'Next Section' }
    },
    {
        formID: 'employmentDetails',
        title: 'Current Employment Details',
        fieldIDTitle: 'employment-details',
        multiple: true,
        fields: CURRENT_EMPLOYMENT_DETAILS_FIELDS,
        submitBtn: { id: 'submit-general', title: 'Review' }
    },
    {
        formID: 'rcaRegistrationDetails',
        title: 'Application Details',
        fields: RCA_REGISTER_DETAILS_FIELDS
    }
];

export default CARegistration;
